import { render, staticRenderFns } from "./AscMxRecRecommendationDetailsWrapper.vue?vue&type=template&id=397a9b78&"
import script from "./AscMxRecRecommendationDetailsWrapper.vue?vue&type=script&lang=js&"
export * from "./AscMxRecRecommendationDetailsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscMxRecRecommendationDetailsWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports